export default __webpack_public_path__ + "static/media/Configuration.af2895dc.png";